import * as Sentry from "@sentry/react";
import { PersonalInfoDetailsAnswer } from "@physiofit-digital/physiofit_types";
import { doc, updateDoc } from "firebase/firestore";
import { getPracticePatient } from "../../../core/store/currentFormSlice";
import { useMainStore } from "../../../core/store/mainStore";
import { addValueIfExists } from "../../../core/utils/addValueIfExists";
import { db } from "../../../firebaseConfig";

export const usePersonalInfoHandling = () => {
  const practicePatient = useMainStore(getPracticePatient);

  // Returns false instead of throwing or resolving silently, so the caller can
  // keep the patient on the question. Sentry captures no console output in this
  // app, so a bare console.error would never reach monitoring (PF-5637).
  const savePersonalInfo = async (
    personalInfo: PersonalInfoDetailsAnswer,
  ): Promise<boolean> => {
    if (!practicePatient?.id) {
      console.error("Patient ID is missing");
      Sentry.captureException(
        new Error("savePersonalInfo: practicePatient id is missing"),
      );
      return false;
    }

    try {
      await updateDoc(doc(db, "practicePatients/" + practicePatient.id), {
        personalInfo: {
          ...practicePatient?.personalInfo,
          firstName: personalInfo.firstName,
          lastName: personalInfo.lastName,
          birthday: personalInfo.birthday,
          email: personalInfo.email,
          ...addValueIfExists("address", personalInfo.address),
        },
        ["flags.hasAcceptedUsageConditions"]: true,
      });
      return true;
    } catch (error) {
      console.error("Error saving personal info:", error);
      Sentry.captureException(error);
      return false;
    }
  };

  return {
    savePersonalInfo,
  };
};
